/**
 * @generated SignedSource<<72dd77de06e0f584196bb444c69547b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentReviewStatus = "NEEDED" | "NONE" | "REVIEWED";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerCardHeaderReviewAction_appointment$data = {
  readonly id: string;
  readonly isCompleted: boolean;
  readonly reviewStatus: AppointmentReviewStatus;
  readonly " $fragmentType": "appointmentDrawerCardHeaderReviewAction_appointment";
};
export type appointmentDrawerCardHeaderReviewAction_appointment$key = {
  readonly " $data"?: appointmentDrawerCardHeaderReviewAction_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerCardHeaderReviewAction_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerCardHeaderReviewAction_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "ac1fb38f1bff51737f97f18921cae3e6";

export default node;
